var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket-info-page"},[_c('Steps',{attrs:{"active":0}}),_c('Tabs',{attrs:{"current":"ticket"}}),_c('TicketList',{attrs:{"type":"TICKET"}}),_c('TicketList',{attrs:{"type":"BATCH"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }